import React, { useState, useEffect } from "react";
import Response_Processing from "../../../../src/layout/Others/Response_Processing";
import { useMyContext } from "../../../components/Provider/CommonProvider";
import { toast } from "react-toastify";
import AdminSaveHeader from "../../../components/CommonComponents/AdminSaveHeader";
import MessageLabel from "../../../components/CommonComponents/MessageLabel";
import AdminSwitch from "../../../components/CommonComponents/AdminSwitch";
import AdminCustomInput from "../../../components/CommonComponents/AdminCustomInput";
import Defaultloadinggif from "../../../layout/Others/Defaultloadinggif";
import AdminTooltip from "../../../components/CommonComponents/AdminTooltip";
import FormContainer from "../../../components/CommonComponents/FormContainer";
import Wrapper from "../../../components/CommonComponents/Wrapper";
import MessageHeading from "../../../components/CommonComponents/MessageHeading";

function SignupMenu() {
  const { fetchRequest } = useMyContext()
  const baseURL = process.env.REACT_APP_Baseurl
  const updateApi = `${baseURL}/admin/signup_menu_store`
  const createApi = `${baseURL}/admin/signup_menu`

  const [loading, setLoading] = useState(false);
  const [withOutRefresh, setWithOutRefresh] = useState(false)
  const [showOverlay, setShowOverlay] = useState(false);

  const [editUser, setEditUser] = useState({
    username: "",
    id: "",
    user_id: "",
    email: "",
    mobile: "",
    avatar: "",
    password: "",
    password_confirm: "",
    DOB: "",
    support_username: "",
    gender: "",
    region: "",
    terms_and_conditions: "",
    list_of_policies: "",
    revenue_share: "",
    editorial_policy: "",
    user_generated_content_policy: "",
    terms_and_conditions_text: "",
    list_of_policies_text: "",
    revenue_share_text: "",
    editorial_policy_text: "",
    user_generated_content_policy_text: "",
    terms_and_conditions_url: "",
    list_of_policies_url: "",
    revenue_share_url: "",
    editorial_policy_url: "",
    user_generated_content_policy_url: "",
  });

  useEffect(async () => {
    setLoading(true)
    await fetchRequest({
      method: 'GET',
      url: `${createApi}`,
      params: {},
      data: {},
    })
      .then((response) => {
        setEditUser(response?.signup_menu)
      }).catch((error) => {
        toast.error(error?.response?.data?.message || "Something went wrong ")
      }).finally(() => {
        setLoading(false)
      })
  }, [withOutRefresh])

  const handleUpdate = async () => {
    setShowOverlay(true);
    try {
      const formDataAdd = {};
      for (const key in editUser) {
        if (!key.startsWith('signup_avatar_')) {
          formDataAdd[key] = editUser[key]
        }
      }
      const response = await fetchRequest({
        method: 'POST',
        url: `${updateApi}`,
        params: {},
        data: formDataAdd,
      })
      const result = response;
      if (result?.status) {
        toast.success(result?.message)
        setWithOutRefresh(!withOutRefresh)
      }
    }
    catch (err) {
      const errorMessage = err?.response?.data?.message
      toast.error(errorMessage)
    }
    finally {
      setShowOverlay(false)
    }
  }

  const handleInput = (e) => {
    const { name, type, checked, value } = e.target;
    if (type === 'checkbox') {
      const avoidUpdate = ["username", "email", "mobile", "password", "password_confirm"]
      if (avoidUpdate.includes(name)) return
      setEditUser((prevEditUser) => ({
        ...prevEditUser,
        [name]: checked ? 1 : 0,
      }));
    } else {
      // Handle text inputs
      setEditUser((prevEditUser) => ({
        ...prevEditUser,
        [name]: value,
      }));
    }
  }

  if (loading) {
    return <Defaultloadinggif className={"heightOnLoader"} />
  }
  return (
    <>
      {showOverlay && (<Response_Processing />)}
      <AdminSaveHeader heading={"Signup Menu"} saveText={"Submit"} saveMethod={handleUpdate} loading={showOverlay} />

      <FormContainer>
        <Wrapper className={"w-100"}>
          <table className={`w-100`}>
            <thead>
              <tr>
                <th key={"id"} className="table-column-heading" style={{ width: "20%" }}>
                  <MessageHeading text={"S.No"} />
                </th>
                <th key={"id"} className="table-column-heading" style={{ width: "70%" }} >
                  <MessageHeading text={"Name"} />
                </th>
                <th key={"id"} className="table-column-heading" style={{ width: "30%" }} >
                  <MessageHeading text={"Status"} />
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td><MessageLabel className="pb-2" text="1" /></td>
                <td><MessageLabel text={"Profile Name"} /></td>
                <td >
                  <div className="d-inline-block position-relative tooltip-container">
                    <AdminSwitch name={'username'} checked={editUser?.username == 1} onChange={handleInput} />
                    <AdminTooltip text="This option is not editable" className="custom-hover-tooltip" position="absolute" bottom="125%" />
                  </div>
                </td>
              </tr>
              <tr>
                <td><MessageLabel className="pb-2" text="2" /></td>
                <td><MessageLabel text={"Profile Email"} /></td>
                <td >
                  <div className="d-inline-block position-relative tooltip-container">
                    <AdminSwitch name={'email'} checked={editUser?.email == 1} onChange={handleInput} />
                    <AdminTooltip text="This option is not editable" className="custom-hover-tooltip" position="absolute" bottom="125%" />
                  </div>
                </td>
              </tr>
              <tr>
                <td><MessageLabel className="pb-2" text="3" /></td>
                <td><MessageLabel text={"Profile Mobile Number"} /></td>
                <td >
                  <div className="d-inline-block position-relative tooltip-container">
                    <AdminSwitch name={'mobile'} checked={editUser?.mobile == 1} onChange={handleInput} />
                    <AdminTooltip text="This option is not editable" className="custom-hover-tooltip" position="absolute" bottom="125%" />
                  </div>
                </td>
              </tr>
              <tr>
                <td><MessageLabel className="pb-2" text="4" /></td>
                <td><MessageLabel text={"Profile Image"} /></td>
                <td >
                  <div className="d-inline-block position-relative tooltip-container">
                    <AdminSwitch name={'avatar'} checked={editUser?.avatar == 1} onChange={handleInput} />
                  </div>
                </td>
              </tr>
              <tr>
                <td><MessageLabel className="pb-2" text="5" /></td>
                <td><MessageLabel text={"Profile Password"} /></td>
                <td >
                  <div className="d-inline-block position-relative tooltip-container">
                    <AdminSwitch name={'password'} checked={editUser?.password == 1} onChange={handleInput} />
                    <AdminTooltip text="This option is not editable" className="custom-hover-tooltip" position="absolute" bottom="125%" />
                  </div>
                </td>
              </tr>
              <tr>
                <td><MessageLabel className="pb-2" text="6" /></td>
                <td><MessageLabel text={"Profile Password Confirm"} /></td>
                <td >
                  <div className="d-inline-block position-relative tooltip-container">
                    <AdminSwitch name={'password_confirm'} checked={editUser?.password_confirm == 1} onChange={handleInput} />
                    <AdminTooltip text="This option is not editable" className="custom-hover-tooltip" position="absolute" bottom="125%" />
                  </div>
                </td>
              </tr>
              <tr>
                <td><MessageLabel className="pb-2" text="7" /></td>
                <td><MessageLabel text={"Profile DOB"} /></td>
                <td >
                  <div className="d-inline-block position-relative tooltip-container">
                    <AdminSwitch name={'DOB'} checked={editUser?.DOB == 1} onChange={handleInput} />
                  </div>
                </td>
              </tr>
              <tr>
                <td><MessageLabel className="pb-2" text="8" /></td>
                <td><MessageLabel text={"Region"} /></td>
                <td >
                  <div className="d-inline-block position-relative tooltip-container">
                    <AdminSwitch name={'region'} checked={editUser?.region == 1} onChange={handleInput} />
                  </div>
                </td>
              </tr>
              <tr>
                <td><MessageLabel className="pb-2" text="9" /></td>
                <td><MessageLabel text={"Profile Support UserName"} /></td>
                <td >
                  <div className="d-inline-block position-relative tooltip-container">
                    <AdminSwitch name={'support_username'} checked={editUser?.support_username == 1} onChange={handleInput} />
                  </div>
                </td>
              </tr>
              <tr>
                <td><MessageLabel className="pb-2" text="10" /></td>
                <td><MessageLabel text={"Gender"} /></td>
                <td >
                  <div className="d-inline-block position-relative tooltip-container">
                    <AdminSwitch name={'gender'} checked={editUser?.gender == 1} onChange={handleInput} />
                  </div>
                </td>
              </tr>
              <tr>
                <td><MessageLabel className="pb-2" text="11" /></td>
                <td><MessageLabel text={"Terms and Conditions"} /></td>
                <td>
                  <div className="d-inline-block position-relative tooltip-container">
                    <AdminSwitch name={'terms_and_conditions'} checked={editUser?.terms_and_conditions == 1} onChange={handleInput} />
                  </div>
                </td>
              </tr>
              {editUser?.terms_and_conditions == 1 && (
                <>
                  <tr>
                    <td></td>
                    <td colSpan="2" className="ps-5">
                      <div className="row align-items-center mb-2">
                        <div className="col-3">
                          <MessageLabel text="Content Title" className="mb-0 " />
                        </div>
                        <div className="col-9">
                          <AdminCustomInput
                            type="text"
                            name="terms_and_conditions_text"
                            value={editUser?.terms_and_conditions_text || 'Accept Terms & Conditions'}
                            onChange={handleInput}
                            placeholder="Enter custom label text"
                            className="w-100"
                          />
                        </div>
                      </div>
                      <div className="row align-items-center">
                        <div className="col-3">
                          <MessageLabel text="Redirection URL" className="mb-0 " />
                        </div>
                        <div className="col-9">
                          <AdminCustomInput
                            type="text"
                            name="terms_and_conditions_url"
                            value={editUser?.terms_and_conditions_url || '/page/terms-and-conditions'}
                            onChange={handleInput}
                            placeholder="Enter URL (e.g., /page/terms-and-conditions)"
                            className="w-100"
                          />
                        </div>
                      </div>
                    </td>
                  </tr>
                </>
              )}
              <tr>
                <td><MessageLabel className="pb-2" text="12" /></td>
                <td><MessageLabel text={"List of Policies"} /></td>
                <td>
                  <div className="d-inline-block position-relative tooltip-container">
                    <AdminSwitch name={'list_of_policies'} checked={editUser?.list_of_policies == 1} onChange={handleInput} />
                  </div>
                </td>
              </tr>
              {editUser?.list_of_policies == 1 && (
                <>
                  <tr>
                    <td></td>
                    <td colSpan="2" className="ps-5">
                      <div className="row align-items-center mb-2">
                        <div className="col-3">
                          <MessageLabel text="Content Title" className="mb-0 " />
                        </div>
                        <div className="col-9">
                          <AdminCustomInput
                            type="text"
                            name="list_of_policies_text"
                            value={editUser?.list_of_policies_text || 'Accept List of Policies'}
                            onChange={handleInput}
                            placeholder="Enter custom label text"
                            className="w-100"
                          />
                        </div>
                      </div>
                      <div className="row align-items-center">
                        <div className="col-3">
                          <MessageLabel text="Redirection URL" className="mb-0 " />
                        </div>
                        <div className="col-9">
                          <AdminCustomInput
                            type="text"
                            name="list_of_policies_url"
                            value={editUser?.list_of_policies_url || '/page/list-of-policies'}
                            onChange={handleInput}
                            placeholder="Enter URL (e.g., /page/list-of-policies)"
                            className="w-100"
                          />
                        </div>
                      </div>
                    </td>
                  </tr>
                </>
              )}
              <tr>
                <td><MessageLabel className="pb-2" text="13" /></td>
                <td><MessageLabel text={"Revenue Share"} /></td>
                <td>
                  <div className="d-inline-block position-relative tooltip-container">
                    <AdminSwitch name={'revenue_share'} checked={editUser?.revenue_share == 1} onChange={handleInput} />
                  </div>
                </td>
              </tr>
              {editUser?.revenue_share == 1 && (
                <>
                  <tr>
                    <td></td>
                    <td colSpan="2" className="ps-5">
                      <div className="row align-items-center mb-2">
                        <div className="col-3">
                          <MessageLabel text="Content Title" className="mb-0 " />
                        </div>
                        <div className="col-9">
                          <AdminCustomInput
                            type="text"
                            name="revenue_share_text"
                            value={editUser?.revenue_share_text || 'Accept Revenue Share Policy'}
                            onChange={handleInput}
                            placeholder="Enter custom label text"
                            className="w-100"
                          />
                        </div>
                      </div>
                      <div className="row align-items-center">
                        <div className="col-3">
                          <MessageLabel text="Redirection URL" className="mb-0 " />
                        </div>
                        <div className="col-9">
                          <AdminCustomInput
                            type="text"
                            name="revenue_share_url"
                            value={editUser?.revenue_share_url || '/page/revenue-share'}
                            onChange={handleInput}
                            placeholder="Enter URL (e.g., /page/revenue-share)"
                            className="w-100"
                          />
                        </div>
                      </div>
                    </td>
                  </tr>
                </>
              )}
              <tr>
                <td><MessageLabel className="pb-2" text="14" /></td>
                <td><MessageLabel text={"Editorial Policy"} /></td>
                <td>
                  <div className="d-inline-block position-relative tooltip-container">
                    <AdminSwitch name={'editorial_policy'} checked={editUser?.editorial_policy == 1} onChange={handleInput} />
                  </div>
                </td>
              </tr>
              {editUser?.editorial_policy == 1 && (
                <>
                  <tr>
                    <td></td>
                    <td colSpan="2" className="ps-5">
                      <div className="row align-items-center mb-2">
                        <div className="col-3">
                          <MessageLabel text="Content Title" className="mb-0 " />
                        </div>
                        <div className="col-9">
                          <AdminCustomInput
                            type="text"
                            name="editorial_policy_text"
                            value={editUser?.editorial_policy_text || 'Accept Editorial Policy'}
                            onChange={handleInput}
                            placeholder="Enter custom label text"
                            className="w-100"
                          />
                        </div>
                      </div>
                      <div className="row align-items-center">
                        <div className="col-3">
                          <MessageLabel text="Redirection URL" className="mb-0 " />
                        </div>
                        <div className="col-9">
                          <AdminCustomInput
                            type="text"
                            name="editorial_policy_url"
                            value={editUser?.editorial_policy_url || '/page/editorial-policy'}
                            onChange={handleInput}
                            placeholder="Enter URL (e.g., /page/editorial-policy)"
                            className="w-100"
                          />
                        </div>
                      </div>
                    </td>
                  </tr>
                </>
              )}
              <tr>
                <td><MessageLabel className="pb-2" text="15" /></td>
                <td><MessageLabel text={"User Generated Content Policy"} /></td>
                <td>
                  <div className="d-inline-block position-relative tooltip-container">
                    <AdminSwitch name={'user_generated_content_policy'} checked={editUser?.user_generated_content_policy == 1} onChange={handleInput} />
                  </div>
                </td>
              </tr>
              {editUser?.user_generated_content_policy == 1 && (
                <>
                  <tr>
                    <td></td>
                    <td colSpan="2" className="ps-5">
                      <div className="row align-items-center mb-2">
                        <div className="col-3">
                          <MessageLabel text="Content Title" className="mb-0 " />
                        </div>
                        <div className="col-9">
                          <AdminCustomInput
                            type="text"
                            name="user_generated_content_policy_text"
                            value={editUser?.user_generated_content_policy_text || 'Accept User Generated Content Policy'}
                            onChange={handleInput}
                            placeholder="Enter custom label text"
                            className="w-100"
                          />
                        </div>
                      </div>
                      <div className="row align-items-center">
                        <div className="col-3">
                          <MessageLabel text="Redirection URL" className="mb-0 " />
                        </div>
                        <div className="col-9">
                          <AdminCustomInput
                            type="text"
                            name="user_generated_content_policy_url"
                            value={editUser?.user_generated_content_policy_url || '/page/user-generated-content-policy'}
                            onChange={handleInput}
                            placeholder="Enter URL (e.g., /page/user-generated-content-policy)"
                            className="w-100"
                          />
                        </div>
                      </div>
                    </td>
                  </tr>
                </>
              )}
            </tbody>
          </table>
        </Wrapper>
      </FormContainer>
    </>
  );
}
export default SignupMenu;